import { render, staticRenderFns } from "./IndividualArticleVariants.vue?vue&type=template&id=6aa9b289"
import script from "./IndividualArticleVariants.vue?vue&type=script&lang=js"
export * from "./IndividualArticleVariants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports